import Vue from "vue";
import VueRouter from "vue-router";
import MainLayout from "@/views/MainLayout.vue";
import OidcCallback from "@/components/OidcCallback.vue";
import OidcCallbackError from "@/components/OidcCallbackError.vue";
import createRouterMiddleware from "@/config/oidc/create-router-middleware";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "start",
        alias: "Start",
        meta: { nav: false },
        component: () =>
          import(/* webpackChunkName: "start" */ "@/views/Start.vue")
      },
      {
        path: "/clients",
        name: "clients",
        alias: "Klienter",
        meta: { nav: true, roles: ["Administrators", "IdentityManager"] },
        component: () =>
          import(
            /* webpackChunkName: "clients" */ "@/views/clients/ClientsList.vue"
          )
      },
      {
        path: "clients/:id",
        name: "client",
        component: () =>
          import(
            /* webpackChunkName: "clients" */ "@/views/clients/Client.vue"
          ),
        props: true,
        meta: {
          nav: false,
          roles: ["Administrators", "IdentityManager"]
        }
      },
      {
        path: "/apiresources",
        name: "apiresources",
        alias: "Api",
        meta: { nav: true, roles: ["Administrators", "IdentityManager"] },
        component: () =>
          import(
            /* webpackChunkName: "apiresources" */ "@/views/apiresources/ApisList.vue"
          )
      },
      {
        path: "apiresources/:id",
        name: "apiresource",
        component: () =>
          import(
            /* webpackChunkName: "apiresources" */ "@/views/apiresources/Api.vue"
          ),
        props: true,
        meta: {
          nav: false,
          roles: ["Administrators", "IdentityManager"]
        }
      },
      {
        path: "/identityresources",
        name: "identityresources",
        alias: "Identity",
        meta: { nav: true, roles: ["Administrators", "IdentityManager"] },
        component: () =>
          import(
            /* webpackChunkName: "identityresources" */ "@/views/identityresources/IdentityList.vue"
          )
      },
      {
        path: "identityresources/:id",
        name: "identityresource",
        component: () =>
          import(
            /* webpackChunkName: "identityresources" */ "@/views/identityresources/Identity.vue"
          ),
        props: true,
        meta: {
          nav: false,
          roles: ["Administrators", "IdentityManager"]
        }
      },
      {
        path: "/users",
        name: "users",
        alias: "Användare",
        meta: { nav: true, roles: ["Administrators", "UserManager"] },
        component: () =>
          import(/* webpackChunkName: "users" */ "@/views/users/UsersList.vue")
      },
      {
        path: "users/:id",
        name: "user",
        component: () =>
          import(/* webpackChunkName: "users" */ "@/views/users/User.vue"),
        props: true,
        meta: {
          nav: false,
          roles: ["Administrators", "UserManager"]
        }
      },
      {
        path: "/roles",
        name: "roles",
        alias: "Roller",
        meta: { nav: true, roles: ["Administrators", "UserManager"] },
        component: () =>
          import(/* webpackChunkName: "roles" */ "@/views/roles/RolesList.vue")
      },
      {
        path: "roles/:id",
        name: "role",
        component: () =>
          import(/* webpackChunkName: "roles" */ "@/views/roles/Role.vue"),
        props: true,
        meta: {
          nav: false,
          roles: ["Administrators", "UserManager"]
        }
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback
  },
  {
    path: "/oidc-callback-error", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallbackError",
    component: OidcCallbackError,
    meta: {
      isPublic: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach(createRouterMiddleware(store, "oidcStore"));

export default router;
